export default "__VITE_ASSET__DsDp3ge___"